<div
  class="wrapper"
  (click)="openChatWidget()"
  [ngClass]="{ loading: loading }"
>
  <div class="icon-wrapper">
    <ng-icon name="featherHelpCircle" size="16"></ng-icon>
  </div>
  <span class="label">{{ loading ? 'Loading...' : 'Help' }}</span>
</div>
